import React from "react";

import "./Audio.css";
import { useGlobalAudio } from "../../context/GlobalAudio/GlobalAudioContext";

const formatTime = (seconds) => {
	if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
	const mins = Math.floor(seconds / 60);
	const secs = Math.floor(seconds % 60);
	return `${mins}:${String(secs).padStart(2, "0")}`;
};

function sameAudioUrl(a, b) {
	if (!a || !b) return false;
	if (a === b) return true;
	try {
		return new URL(a, window.location.href).href === new URL(b, window.location.href).href;
	} catch (_) {
		return false;
	}
}

export default function Audio({ url, title = "Áudio", ticketId = null }) {
	const {
		src,
		isPlaying,
		currentTime,
		duration,
		playbackRate,
		play,
		toggle,
		seekRatio,
		cycleRate,
	} = useGlobalAudio();

	const meta = { title, ticketId };
	const isActive = sameAudioUrl(src, url);
	const playingHere = isActive && isPlaying;
	const localTime = isActive ? currentTime : 0;
	const localDuration = isActive ? duration : 0;
	const progress = localDuration > 0 ? (localTime / localDuration) * 100 : 0;
	const displayTime =
		playingHere || (isActive && localTime > 0) ? localTime : localDuration;

	const handleSeek = async (event) => {
		const ratio = event.target.value;
		if (!isActive) {
			await play(url, meta);
		}
		seekRatio(ratio);
	};

	return (
		<div className="chat-audio-player">
			<button
				type="button"
				className="chat-audio-player__speed"
				onClick={cycleRate}
				aria-label={`Velocidade ${playbackRate}x`}
				title={`Velocidade ${playbackRate}x`}
			>
				{playbackRate}x
			</button>

			<button
				type="button"
				className="chat-audio-player__play"
				onClick={() => toggle(url, meta)}
				aria-label={playingHere ? "Pausar áudio" : "Reproduzir áudio"}
			>
				{playingHere ? (
					<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
						<rect x="6" y="5" width="4" height="14" rx="1" />
						<rect x="14" y="5" width="4" height="14" rx="1" />
					</svg>
				) : (
					<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
						<path d="M8 5v14l11-7z" />
					</svg>
				)}
			</button>

			<div className="chat-audio-player__track">
				<input
					type="range"
					min="0"
					max="100"
					step="0.1"
					value={isActive ? progress : 0}
					onChange={handleSeek}
					onPointerDown={(e) => {
						if (!isActive) {
							play(url, meta);
						}
						e.stopPropagation();
					}}
					className="chat-audio-player__range"
					aria-label="Progresso do áudio"
					style={{
						"--audio-progress": `${isActive ? progress : 0}%`,
					}}
				/>
			</div>

			<span className="chat-audio-player__time">{formatTime(displayTime)}</span>
		</div>
	);
}
